export default "__VITE_ASSET__f3d8e278__"